var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/Message/Message.js";
import React from "react";
import PropTypes from "prop-types";
var Message = function Message(_ref) {
  var message = _ref.message,
    _ref$optionalImage = _ref.optionalImage,
    optionalImage = _ref$optionalImage === void 0 ? null : _ref$optionalImage;
  var parseResponse = function parseResponse(html) {
    return {
      __html: html
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "survey-Message",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, optionalImage, /*#__PURE__*/React.createElement("div", {
    "data-testid": "Message",
    dangerouslySetInnerHTML: parseResponse(message),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }));
};
Message.propTypes = {
  message: PropTypes.string.isRequired,
  optionalImage: PropTypes.element
};
export { Message as default };